import { API_URLS } from "../config";

// ── In-memory TTL cache (brands + families, valid 5 min) ──────────────────────
const _cache = {};
const CACHE_TTL = 5 * 60 * 1000;

function isFresh(key) {
  return _cache[key] && Date.now() - _cache[key].ts < CACHE_TTL;
}

// ── Store ─────────────────────────────────────────────────────────────────────

const store = {
  cart: [],

  // Returns { brands, families } — single HTTP call, cached 5 min
  getCatalogMeta: async function () {
    if (isFresh("catalogMeta")) return _cache.catalogMeta.data;
    try {
      const data = await fetch(API_URLS.catalogMeta).then(r => r.json());
      _cache.catalogMeta = { data, ts: Date.now() };
      return data;
    } catch (error) {
      console.error("Erreur lors de la récupération du catalogue meta:", error);
      return { brands: [], families: [] };
    }
  },

  // Returns full article data for one ref — used by Article.js detail page
  getArticleByRef: async function (ref) {
    const cacheKey = `article:${ref}`;
    if (isFresh(cacheKey)) return _cache[cacheKey].data;
    try {
      const params = new URLSearchParams({ ref });
      const data = await fetch(`${API_URLS.article}?${params}`).then(r => r.json());
      if (data && !data.error) {
        _cache[cacheKey] = { data, ts: Date.now() };
      }
      return data || null;
    } catch (error) {
      console.error("Erreur lors de la récupération de l'article:", error);
      return null;
    }
  },

  getBrands: async function () {
    if (isFresh("brands")) return _cache.brands.data;
    try {
      const data = await fetch(API_URLS.brands).then(r => r.json());
      _cache.brands = { data: data || [], ts: Date.now() };
      return _cache.brands.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des marques:", error);
      return [];
    }
  },

  getFamilies: async function () {
    if (isFresh("families")) return _cache.families.data;
    try {
      const data = await fetch(API_URLS.families).then(r => r.json());
      _cache.families = { data: data || [], ts: Date.now() };
      return _cache.families.data;
    } catch (error) {
      console.error("Erreur lors de la récupération des familles:", error);
      return [];
    }
  },

  searchProduct(str) {
    const filters = `where=(Reference,like,${str})~or(Désignation,like,${str})~or(Fabricants,like,${str})~and(Publié,eq,1)`;
    return this.getProductsByCategory({ type: "search", filters, page: 1 });
  },

  getProductByReference(ref) {
    const filters = `where=(Reference,eq,${ref})~and(Publié,eq,1)`;
    return this.getProductsByCategory({ type: "search", filters, page: 1 });
  },

  getProductsByCategory: async function ({
    type,
    brand,
    family,
    subFamily,
    filters = "where=(Publié,eq,1)",
    page = 1,
    rowsLimit = 20,
  }) {
    try {
      const params = new URLSearchParams();
      if (type) params.set("type", type);
      if (brand) params.set("brand", brand);
      if (family) params.set("family", family);
      if (subFamily) params.set("subFamily", subFamily);
      if (filters) params.set("filters", filters);
      params.set("page", page);
      params.set("rowsLimit", rowsLimit);

      const url = `${API_URLS.products}?${params.toString()}`;
      const response = await fetch(url);
      const data = await response.json();

      return data || { list: [], pageInfo: {} };
    } catch (error) {
      console.error("Erreur lors de la récupération des produits:", error);
      return { list: [], pageInfo: {} };
    }
  },
};

export default store;
